import type { FormRecognitionConfig } from '@capture/shared';

type Policy = FormRecognitionConfig['multiFormBatchPolicy'];

interface Props {
  threshold: number;
  policy: Policy;
  onChangeThreshold: (t: number) => void;
  onChangePolicy: (p: Policy) => void;
}

const POLICIES: { value: Policy; label: string }[] = [
  { value: 'allow', label: 'Allow' },
  { value: 'disallow', label: 'Disallow' },
];

export function ThresholdBlock({
  threshold,
  policy,
  onChangeThreshold,
  onChangePolicy,
}: Props) {
  return (
    <div className="threshold-block">
      <h3 className="threshold-block__title">CONFIDENCE &amp; POLICY</h3>
      <div className="threshold-block__row">
        <label className="threshold-block__label">
          <span>Confidence threshold</span>
          <input
            className="threshold-block__input"
            type="number"
            value={threshold}
            onChange={(e) => onChangeThreshold(Number(e.target.value))}
            min={0}
            max={1}
            step={0.05}
          />
        </label>
      </div>
      <fieldset className="threshold-block__fieldset">
        <legend className="threshold-block__legend">
          Multi-form batch policy
        </legend>
        {POLICIES.map((p) => (
          <label key={p.value} className="threshold-block__radio-label">
            <input
              type="radio"
              name="multiFormBatchPolicy"
              value={p.value}
              checked={policy === p.value}
              onChange={() => onChangePolicy(p.value)}
            />
            {p.label}
          </label>
        ))}
      </fieldset>
    </div>
  );
}
